// 判断是否叶子节点
const isLeaf = (data, prop) => {
  return !(Array.isArray(data[prop]) && data[prop].length > 0)
}

// 创建 node 节点
export const renderNode = (h, data, context) => {
  const { props } = context
  const cls = ['org-tree-node']
  const childNodes = []
  const children = data[props.props.children]
  if (isLeaf(data, props.props.children)) {
    cls.push('is-leaf')
    data['isLeaf'] = true
  } else if (props.collapsable && !data[props.props.expand]) {
    cls.push('collapsed')
  }
  if (data.isGroupLeader) {
    let arr = []
    arr.push(h('span', {
      style: {
        'background': 'rgb(204, 204, 204)',
        'padding': '2px 4px'
      }
    }, data.groupName))
    childNodes.push(h('span', {
      style: {
        'position': 'absolute',
        'top': '-10px',
        'width': '100%',
        'left': '0',
        'z-index': 4,
        'text-align': 'center'
      } }, arr))
  }
  childNodes.push(renderLabel(h, data, context))

  if (!props.collapsable || data[props.props.expand]) {
    childNodes.push(renderChildren(h, children, context))
  }
  // 分组
  if ((Array.isArray(data['groupList']) && data['groupList'].length > 0)) {
    console.log(props.data)
    childNodes.push(getGroupItem(h, data['groupList'], context))
  }
  // brotherList
  if ((Array.isArray(data['brotherList']) && data['brotherList'].length > 0)) {
    console.log(props.data)
    childNodes.push(getGroupItem(h, data['brotherList'], context))
  }
  if (data.isGroupLeader || data.brotherList) {
    let groupNodeArr = []
    let classStr = data.isGroupLeader ? cls.join(' ') + ' org-tree-node-group' : cls.join(' ')
    groupNodeArr.push(h('div', {
      domProps: {
        className: classStr
      }
    }, childNodes))
    return h('div', {
      domProps: {
        className: cls.join(' ')
      }
    }, groupNodeArr)
  } else {
    // 如果是根节点
    if(data.isRoot){
      return h('div', {
              domProps: {
                className: cls.join(' ')
              }
            }, childNodes)
    }
    return h('div', {
      domProps: {
        className: ' org-tree-node is-leaf '
      }
    }, [h('div', {
      domProps: {
        className: cls.join(' ')
      }
    }, childNodes)])
  }
}

// 创建 label 节点
export const renderLabel = (h, data, context, addBr) => {
  const { props } = context
  const label = data[props.props.label]
  const nodeRender = props.nodeRender
  const clickHandler = context.listeners['on-node-click']
  const rightClickHandler = context.listeners['on-node-right-click']
  const mousedownHandler = context.listeners['on-node-mousedown']
  const mouseupHandler = context.listeners['on-node-mouseup']
  const touchstartHandler = context.listeners['on-node-touchstart']
  const touchleaveHandler = context.listeners['on-node-touchleave']

  const childNodes = []
  if (typeof nodeRender === 'function') {
    let vnode = nodeRender(h, data)

    vnode && childNodes.push(vnode)
  } else {
    childNodes.push(label)
  }
  const cls = ['org-tree-node-label-inner']
  let { labelWidth, labelClassName } = props
  if (typeof labelWidth === 'number') {
    labelWidth += 'px'
  }
  if (typeof labelClassName === 'function') {
    labelClassName = labelClassName(data)
  }
  labelClassName && cls.push(labelClassName)
  if (addBr) {
    return h('div', {
      style: {
        display: 'block'
      },
      domProps: {
        className: 'org-tree-node-label'
      },
      on: {
        click: e => clickHandler && clickHandler(e, data),
        contextmenu: e => {
          e.preventDefault()
          rightClickHandler && rightClickHandler(e, data)
        },
        mousedown: e => mousedownHandler && mousedownHandler(e, data),
        mouseup: e => mouseupHandler && mouseupHandler(e, data),
        touchstart: e => touchstartHandler && touchstartHandler(e, data),
        touchleave: e => touchleaveHandler && touchleaveHandler(e, data)
      }
    }, [h('div', {
      domProps: {
        className: cls.join(' ')
      },
      style: { width: labelWidth }
    }, childNodes)])
  }
  return h('div', {
    domProps: {
      className: 'org-tree-node-label'
    },
    on: {
      click: e => clickHandler && clickHandler(e, data),
      contextmenu: e => {
        e.preventDefault()
        rightClickHandler && rightClickHandler(e, data)
      },
      mousedown: e => mousedownHandler && mousedownHandler(e, data),
      mouseup: e => mouseupHandler && mouseupHandler(e, data),
      touchstart: e => touchstartHandler && touchstartHandler(e, data),
      touchleave: e => touchleaveHandler && touchleaveHandler(e, data)
    }
  }, [h('div', {
    domProps: {
      className: cls.join(' ')
    },
    style: { width: labelWidth }
  }, childNodes)])
}

export const getGroupItem = (h, list, context) => {
  if (Array.isArray(list) && list.length) {
    const groupItem = list.map(item => {
      item['isLeaf'] = true
      item['isGroupItem'] = true
      return renderLabel(h, item, context, true)
    })

    return groupItem
  }
  return ''
}

// 创建 node 子节点
export const renderChildren = (h, list, context) => {
  if (Array.isArray(list) && list.length) {
    const children = list.map(item => {
      return renderNode(h, item, context)
    })

    return h('div', {
      domProps: {
        className: 'org-tree-node-children'
      }
    }, children)
  }
  return ''
}

export const render = (h, context) => {
  const { props } = context
  return renderNode(h, props.data, context)
}

export default render
